const detailsFileHeadersMap = {
  "Product Selector": [
    { label: "Created by", key: "createdBy" },
    { label: "Email", key: "emailId" },
    { label: "Created on", key: "createdDate" },
    { label: "Product selector name", key: "productSelectorName" },
    { label: "Product selector values", key: "productSelector" },
    { label: "Viewed recommendation", key: "viewedRecommendation" },
    { label: "Saved recommendation", key: "savedRecommendation" },
  ],
  "Wound Management": [
    { label: "Created by", key: "createdBy" },
    { label: "Email", key: "emailId" },
    { label: "Created on", key: "createdDate" },
    { label: "# Of Non paid Wound assessments", key: "nonPaidWoundRequest" },
    { label: "# Number of demo requested", key: "demoRequest" },
  ],
  "Product Search": [
    { label: "Searched by", key: "searchedBy" },
    { label: "Email", key: "emailId" },
    { label: "Searched on", key: "searchedDate" },
    { label: "Search keyword", key: "searchKeyword" },
    { label: "Search result - Found/Not found", key: "searchResult" },
  ],
  "OR Pads": [
    { label: "created by", key: "createdBy" },
    { label: "Email", key: "emailId" },
    { label: "Created on", key: "createdDate" },
    { label: "OR pads count", key: "orPadCount" },
    { label: "Stretcher pads count", key: "stretcherPadCount" },
  ],
  "Protein needs calculator": [
    { label: "created by", key: "createdBy" },
    { label: "Email", key: "emailId" },
    { label: "Created on", key: "createdDate" },
    { label: "Count", key: "count" },
  ],
  "NE1 WMS(Paid customers)": [
    { label: "created by", key: "createdBy" },
    { label: "Email", key: "emailId" },
    { label: "Created on", key: "createdDate" },
    { label: "Wound photo", key: "image" },
    { label: "Wound ID", key: "woundId" },
    { label: "Re-eval ID", key: "reEvalId" },
    { label: "Patient's name", key: "patientName" },
  ],
  "NE1 WMS(Offline Patients)": [
    { label: "Added by", key: "addedBy" },
    { label: "Email", key: "emailId" },
    { label: "Date", key: "addedDate" },
    { label: "# Of Patients added to offline", key: "noOfOffline" },
  ],
  "Risk Assessment": [
    { label: "created by", key: "createdBy" },
    { label: "Email", key: "emailId" },
    { label: "Created on", key: "createdDate" },
    { label: "Count", key: "count" },
  ],
};

export const getAnalyticsUserHeader = (option) => {
    return detailsFileHeadersMap[option] || [];
}